import React from 'react';
export var Kebab = function (_a) {
    var color = _a.color;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", color: color !== null && color !== void 0 ? color : 'inherit' },
        React.createElement("circle", { cx: 8, cy: 3.295, r: 1.412, fill: "currentColor" }),
        React.createElement("circle", { cx: 8, cy: 8, r: 1.412, fill: "currentColor" }),
        React.createElement("circle", { cx: 8, cy: 12.707, r: 1.412, fill: "currentColor" })));
};
